
const { ccclass, property, disallowMultiple, requireComponent, menu } = cc._decorator;

@ccclass
@disallowMultiple
@requireComponent(cc.Sprite)
@menu('Framework/UI组件/BaseStateSprite')
export default class BaseStateSprite extends cc.Component {

    @property(cc.SpriteFrame)
    _defaultSpriteFrame: cc.SpriteFrame = null;
    @property({
        type: cc.SpriteFrame
        , displayName: '初始状态'
        , tooltip: '初始的状态'
    })
    get defaultSpriteFrame() {
        return this._defaultSpriteFrame;
    }

    set defaultSpriteFrame(value) {
        this._defaultSpriteFrame = value;
        this.refreshState();
    }

    @property({
        type: cc.SpriteFrame
        , displayName: '填充状态'
        , tooltip: '填充后的状态'
    })
    fillSpriteFrame: cc.SpriteFrame = null;

    // 填充
    @property
    _isFill: boolean = false;
    @property({
        displayName: '是否填充'
        , tooltip: '是否填充'
    })
    get isFill() {
        return this._isFill;
    }
    set isFill(value) {
        this._isFill = value;
        this.refreshState();
    }

    private _defaultSprite: cc.Sprite = null;

    onLoad() {

    }

    start() {
        if (!this._defaultSprite) {
            this.setData();
        }
    }

    setData() {
        let sprite = this.node.getComponent(cc.Sprite);
        this._defaultSprite = sprite;
    }

    setFill(value: boolean) {
        if (this._isFill == value) {
            return;
        }
        this._isFill = value;
        this.refreshState();
    }

    refreshState() {
        if (!this._defaultSprite) {
            this.setData();
        }
        if (this._isFill) {
            this._defaultSprite.spriteFrame = this.fillSpriteFrame;
        } else {
            this._defaultSprite.spriteFrame = this.defaultSpriteFrame;
        }
    }
}
